// @ts-nocheck

export type TenantGetWithRoomPropertyOwner = typeof TenantGetWithRoomPropertyOwner[keyof typeof TenantGetWithRoomPropertyOwner];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TenantGetWithRoomPropertyOwner = {
  true: 'true',
  false: 'false',
} as const;
